export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-8">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-50 rounded-full mb-3 whitespace-nowrap">
              投稿咨询
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              联系我们
            </h2>
            <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
              有想看的影片？有好的资源推荐？欢迎随时与我们取得联系
            </p>
          </div>

          <div className="max-w-[640px] mx-auto bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/70">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
              <div className="flex flex-col items-center gap-2 p-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-mail-line text-xl text-accent-600"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-800">邮件投稿</h3>
                <p className="text-xs text-foreground-500">发送至官方邮箱</p>
                <span className="text-sm text-primary-600 font-medium whitespace-nowrap">tougao@chengquan.tv</span>
              </div>

              <div className="flex flex-col items-center gap-2 p-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-wechat-line text-xl text-accent-600"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-800">微信交流</h3>
                <p className="text-xs text-foreground-500">关注官方公众号</p>
                <span className="text-sm text-primary-600 font-medium whitespace-nowrap">成全影院官方号</span>
              </div>

              <div className="flex flex-col items-center gap-2 p-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-feedback-line text-xl text-accent-600"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-800">意见反馈</h3>
                <p className="text-xs text-foreground-500">帮助我们改进体验</p>
                <span className="text-sm text-primary-600 font-medium whitespace-nowrap">在线提交反馈</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}